let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6IfzY")).then(() => parcelRequire('2MwfB'));